import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "close"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-close',
    templateUrl: './icon-close.component.html',
    styleUrls: ['./icon-close.component.scss'],
    standalone: false
})
export class IconCloseComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
